import { SAVE_SOCK_SOURCE } from '../../util/actionTypes';

const initialState = { source: null };

const sockSourceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_SOCK_SOURCE:
            return {
                ...state,
                source: action.payload
            };
        default:
            return state;
    }
};

export default sockSourceReducer;
